export default "__VITE_ASSET__BBiZ8pYo__"